export const PERIOD_TYPE = {
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
} as const;

export type PeriodType = (typeof PERIOD_TYPE)[keyof typeof PERIOD_TYPE];

export const PERFORMANCE_TAB = {
  TIMELINE: 'timeline',
  TABLE: 'table',
  CHART: 'chart',
} as const;

export type PerformanceTab = (typeof PERFORMANCE_TAB)[keyof typeof PERFORMANCE_TAB];

export const EFFICIENCY_LEVEL = {
  OPTIMAL: 'optimal',
  GOOD: 'good',
  REGULAR: 'regular',
  LOW: 'low',
} as const;

export type EfficiencyLevel = (typeof EFFICIENCY_LEVEL)[keyof typeof EFFICIENCY_LEVEL];

export interface PerformanceSummary {
  totalTasks: number;
  activeMembersCount: number;
  averageEfficiency: number;
  realCost: number;
  estimatedCost: number;
  deviation: number;
}

export interface DailyPerformance {
  date: string;
  efficiency: number | null;
  taskCount: number;
}

export interface MemberTimelineEntry {
  memberId: string;
  memberName: string;
  memberAvatarUrl: string | null;
  schedule?: string;
  hourlyRate?: number;
  dailyData: DailyPerformance[];
}

export interface MemberTableEntry {
  memberId: string;
  memberName: string;
  memberAvatarUrl: string | null;
  hourlyRate: number;
  totalTasks: number;
  estimatedMinutes: number;
  realMinutes: number;
  estimatedCost: number;
  realCost: number;
  gainLoss: number;
  efficiency: number;
}

export interface ProjectPerformanceEntry {
  projectId: string;
  projectName: string;
  memberCount: number;
  efficiency: number;
  members: MemberTimelineEntry[];
}

export interface PerformanceFilters {
  periodStart: string;
  periodEnd: string;
  memberSearch?: string;
}

export interface DayColumn {
  date: string;
  dayNumber: number;
  dayLabel: string;
}

export interface EfficiencyTrendPoint {
  date: string;
  dayLabel: string;
  [memberId: string]: number | string | null;
}
